.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--card-w-md), 1fr));
  gap: var(--sp-4) var(--sp-3);
  margin-top: var(--sp-4);
}

.cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-2);
  padding: 0;
}

.caption {
  text-align: center;
  /* Имена вроде «Королева пентаклей» не помещаются в ширину карты —
     двух строк хватает всем, третья уже ломает ритм сетки. */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.meanings {
  width: 100%;
  padding: var(--sp-5);
}

.back {
  color: var(--c-accent);
  font: var(--t-label-l);
  min-height: var(--tap-min);
}
